import { ButtonNew as Button } from "components/buttonNew";
import { WebsiteBuilderPanelContent } from "pages/secure/facility/websiteBuilder/editor/shell/panel/content/WebsiteBuilderPanelContent";
import { CustomColorPickerPopover } from "components/colorpicker";
import TextField from "components/form/textField/TextField";
import { TWebsiteBuilderHandleDebouncedUpdateState } from "pages/secure/facility/websiteBuilder/editor/hooks/debouncedUpdate/useWebsiteBuilderDebouncedUpdate";
import { IWebsiteBuilderMarqueeParagraphItem, IWebsiteBuilderMarqueeSettings } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderMarquee";
import { WEBSITE_BUILDER_PORTAL } from "pages/secure/facility/websiteBuilder/editor/WebsiteBuilderEditor";
import React from "react";
import { useTranslation } from "react-i18next";

interface IMarqueeSettingsEditParagraphViewProps {
  item: IWebsiteBuilderMarqueeParagraphItem;
  handleDebouncedUpdateState: TWebsiteBuilderHandleDebouncedUpdateState<IWebsiteBuilderMarqueeSettings>;
  onBack: () => void;
  closeSettings: () => void;
}

export function MarqueeSettingsEditParagraphView(props: IMarqueeSettingsEditParagraphViewProps) {
  const { item, handleDebouncedUpdateState, onBack, closeSettings } = props;

  const { t } = useTranslation();

  return (
    <WebsiteBuilderPanelContent
      title={t("Edit paragraph")}
      closePanel={closeSettings}
      sections={[
        <React.Fragment key="edit-paragraph">
          <TextField
            label={t("Text")}
            value={item.settings.text}
            autoFocus
            noResize
            rows={4}
            onChange={e => {
              const text = e.target.value;

              handleDebouncedUpdateState(prev => ({
                ...prev,
                items: prev.items.map(prevItem => prevItem.id === item.id && prevItem.type === "paragraph"
                  ? { ...prevItem, settings: { ...prevItem.settings, text } }
                  : prevItem),
              }));
            }}
          />
          <CustomColorPickerPopover
            title={t("Color")}
            hexColor={item.settings.color}
            updateHexColor={color => {
              handleDebouncedUpdateState(prev => ({
                ...prev,
                items: prev.items.map(prevItem => prevItem.id === item.id && prevItem.type === "paragraph"
                  ? { ...prevItem, settings: { ...prevItem.settings, color } }
                  : prevItem),
              }));
            }}
            portalParentId={WEBSITE_BUILDER_PORTAL}
          />
        </React.Fragment>,
      ]}
      footer={(
        <Button size="small" type="secondary" onClick={onBack} block>
          {t("Go back")}
        </Button>
      )}
    />
  );
}